import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./PermissionForm.form";
import { withEmptyOption } from "../../../../utils";

const permissionController = new Permission();

const sections = [
  "Categorías de pago",
  "Gestión de asistencia",
  "Ciclos académicos",
  "Grados",
  "Mallas curriculares",
  "Asignaturas",
  "Usuarios",
  "Tipos de usuario",
  "Permisos",
  "Notificaciones",
  "PRUEBA",
];

const sectionOptions = sections.map((section) => ({
  key: section,
  value: section,
  text: section,
}));

export function PermissionForm(props) {
  const { onClose, onReload, permission } = props;
  const { accessToken } = useAuth();

  /**
   * Initializes the formik object with initial values, validation schema, and submit handler.
   *
   * @param {Object} permission - The permission object used to initialize the form values.
   * @param {Function} initialValues - Function to get the initial values for the form.
   * @param {Function} validationSchema - Function to get the validation schema for the form.
   * @param {Function} onReload - Function to call when the form submission is successful to reload data.
   * @param {Function} onClose - Function to call when the form submission is successful to close the form.
   * @param {string} accessToken - The access token used to authenticate the request.
   * @param {Object} permissionController - The controller object with methods to create and update permissions.
   *
   * @returns {Object} formik - The formik object with form state and handlers.
   */
  const formik = useFormik({
    initialValues: initialValues(permission),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
          description: formValue.description,
          section: formValue.section,
          action: formValue.action,
        };

        if (permission) {
          await permissionController.updatePermission(permission.id, data);
        } else {
          data.status = true;
          await permissionController.createPermission(data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre de permiso"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Input
        name="action"
        label="Acción (formato: palabra.palabra)"
        onChange={formik.handleChange}
        value={formik.values.action}
        error={formik.errors.action}
      />
      <Form.Select
        className="edunova-select"
        name="section"
        label="Módulo"
        placeholder="Selecciona un módulo"
        clearable
        options={withEmptyOption(sectionOptions, "Selecciona un módulo")}
        onChange={(_, data) => formik.setFieldValue("section", data.value)}
        value={formik.values.section}
        error={formik.errors.section}
      />
      <Form.TextArea
        name="description"
        label="Descripción de permiso"
        onChange={formik.handleChange}
        value={formik.values.description}
        error={formik.errors.description}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {permission ? "Actualizar permiso" : "Crear permiso"}
      </Form.Button>
    </Form>
  );
}
